import { createAsyncThunk } from "@reduxjs/toolkit";
import { addTrainerService, getTrainerService } from "../../../../../utils/services/userManagement/trainer/trainerService";


//for getting trainer's list
export const getTrainer = createAsyncThunk(
    "/trainer/get",
    async (payload, thunkAPI) => {
        console.log("trainer // payload in action  ", payload)
        const response = await getTrainerService(payload);
        if (response?.error) {
            return thunkAPI.rejectWithValue(response?.error);
        }
        return response;
    }
);

//for adding Trainer 
export const addTrainer = createAsyncThunk(
    "/trainer/get",
    async (payload, thunkAPI) => {
        console.log("trainer // payload in action  post ", payload);
        const response = await addTrainerService(payload);
        if (response?.error) {
            return thunkAPI.rejectWithValue(response?.error);
        }
        return response;
    }
);

